var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pages-getMore"},[_c('OpenApp',{attrs:{"btnStyle":_vm.btnStyle,"extinfo":'ivydadReadtool://detail/coursePackage?id=0&course_id=14'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }